"use client";
import Link from "next/link";
import { useState, useEffect } from "react";
import {
  FaMagnifyingGlass,
  FaCirclePlus,
  FaFolder,
  FaChevronRight,
} from "react-icons/fa6";
import { useRouter } from "next/navigation";

export default function LikesNavbar({
  activeTab,
  setActiveTab,
  searchTerm,
  setSearchTerm,
  folders,
  folderFilter,
  setFolderFilter,
}) {
  const [lazySearch, setLazySearch] = useState(searchTerm);
  const router = useRouter();

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setSearchTerm(lazySearch);
    }, 1500);
    return () => clearTimeout(timeoutId);
  }, [lazySearch]);

  return (
    <div className="w-full">
      <div className="mx-auto max-w-xl bg-c1 p-3 text-white shadow-lg rounded-b-lg">
        {/* ردیف بازگشت + عنوان */}
        <div className="grid grid-cols-[40px_1fr_40px] items-center">
          <div className="flex justify-end">
            <button
              type="button"
              onClick={() => router.back()}
              className="transition-transform hover:scale-105 active:scale-95 text-sm font-medium"
              aria-label="بازگشت"
            >
              <FaChevronRight size={24} className="text-white/90" />
            </button>
          </div>

          <div className="text-center">
            <div className="text-sm font-bold">
              قصه شب برای همه کودکان این سرزمین
            </div>
            <div className="text-xs opacity-80 mt-0.5">
              (بنیاد نظریانی |{" "}
              <a
                href="https://nazariani.org"
                target="_blank"
                rel="noopener noreferrer"
              >
                Nazariani.org
              </a>
              )
            </div>
          </div>

          <div></div>
        </div>

        {/* تب‌بار */}
        <div className="mt-3 flex items-center justify-center gap-1 border-t border-white/10 pt-2">
          <button
            type="button"
            onClick={() => setActiveTab("narrators")}
            className={`px-4 py-1.5 text-sm font-medium rounded-full transition-colors ${activeTab === "narrators"
                ? "bg-c3 text-c1"
                : "text-gray-300 hover:text-white"
              }`}
          >
            گویندگان
          </button>
          <button
            type="button"
            onClick={() => setActiveTab("likes")}
            className={`px-4 py-1.5 text-sm font-medium rounded-full transition-colors ${activeTab === "likes"
                ? "bg-c3 text-c1"
                : "text-gray-300 hover:text-white"
              }`}
          >
            علاقه‌مندی‌ها
          </button>
        </div>

        {/* جستجو و فولدرها فقط برای تب علاقه‌مندی‌ها */}
        {activeTab === "likes" && (
          <>
            <div className="relative mt-3">
              <div className="absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none text-white">
                <FaMagnifyingGlass />
              </div>
              <input
                value={lazySearch}
                onInput={(e) => setLazySearch(e.target.value)}
                type="text"
                className="text-white bg-c2 text-xs rounded-lg block w-full ps-10 p-2.5 shadow-lg"
                placeholder="جستجو"
              />
            </div>
            <div
              className="mt-3 flex items-center gap-1 md:pb-1"
              style={{ overflowY: "hidden", overflowX: "auto" }}
            >
              <Link
                href="/folder/create"
                className="text-center bg-c2 text-xs p-1 px-4 rounded-full cursor-pointer text-c3/90 border border-dashed border-c3/50 hover:text-c3 shadow-lg hover:shadow-none"
                style={{ minWidth: "max-content" }}
              >
                <div
                  className="flex items-center justify-center gap-1"
                  style={{ minWidth: "max-content" }}
                >
                  <FaCirclePlus />
                  <span>افزودن پوشه</span>
                </div>
              </Link>

              <div
                onClick={() => setFolderFilter(0)}
                className={`text-center bg-c2 text-xs p-1 px-4 rounded-full cursor-pointer hover:text-c3 ${folderFilter === 0 && "text-c3"
                  } shadow-lg hover:shadow-none`}
                style={{ minWidth: "max-content" }}
              >
                <div
                  className="flex items-center justify-center gap-1"
                  style={{ minWidth: "max-content" }}
                >
                  <FaFolder />
                  <span>همه</span>
                </div>
              </div>

              {folders.map((c) => (
                <div
                  onClick={() => setFolderFilter(c.id)}
                  key={c.id}
                  className={`text-center bg-c2 text-xs p-1 px-4 rounded-full cursor-pointer hover:text-c3 ${folderFilter === c.id && "text-c3"
                    } shadow-lg hover:shadow-none`}
                  style={{ minWidth: "max-content" }}
                >
                  <div
                    className="flex items-center justify-center gap-1"
                    style={{ minWidth: "max-content" }}
                  >
                    <FaFolder />
                    <span>{c.name}</span>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
